import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
export function MemberManagement() {
  const [activeTab, setActiveTab] = useState<'list' | 'add'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    profession: '',
    age: '',
    education: '',
    division: '',
    district: '',
    upazila: '',
    union: '',
    village: '',
    range: '',
    station: '',
    bloodGroup: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    Satkhira: ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    Khulna: ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    Chandpai: ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    Sarankhola: ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  const members = [{
    photo: '👤',
    name: 'Abdur Rahman',
    email: 'abdur@member.com',
    idNumber: 'MBR-001',
    phone: '01711111111',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Jalal Uddin',
    email: 'jalal@member.com',
    idNumber: 'MBR-002',
    phone: '01822222222',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Rina Begum',
    email: 'rina@member.com',
    idNumber: 'MBR-003',
    phone: '01933333333',
    status: 'approved' as const
  }, {
    photo: '👤',
    name: 'Kamrul Hasan',
    email: 'kamrul@member.com',
    idNumber: 'MBR-004',
    phone: '01644444444',
    status: 'pending' as const
  }, {
    photo: '👤',
    name: 'Shirin Akter',
    email: 'shirin@member.com',
    idNumber: 'MBR-005',
    phone: '01555555555',
    status: 'approved' as const
  }];
  const columns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-1422" data-mp="3rm2bpdp8stey">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'idNumber',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-1423" data-mp="3cujmqqeenojg" />
  }];
  const filters = [{
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter member personal information'
  }, {
    title: 'Address Details',
    description: 'Enter address details'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-1424" data-mp="27mh2rs2crq1x">
      <div data-id="element-1425" data-mp="27pwfio8k0n06">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1426" data-mp="23mqepw47no13">Member Management</h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-1427" data-mp="23ot2e9hw552n">
          Manage conservation group members
        </p>
      </div>

      <div className="border-b border-gray-200" data-id="element-1428" data-mp="1twx530nmpizh">
        <div className="flex gap-4" data-id="element-1429" data-mp="1tv2izj0mfktt">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1430" data-mp="1oxk6xjrb4phl">
            Member List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-1431" data-mp="1ax9guixtnexh">
            Add Member
          </button>
        </div>
      </div>

      {activeTab === 'list' && <DataTable columns={columns} data={members} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search members..." data-id="element-1432" data-mp="369bzw02rvkv0" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Member ${formData.fullName} registered successfully!`);
      setCurrentStep(0);
      setActiveTab('list');
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        profession: '',
        age: '',
        education: '',
        division: '',
        district: '',
        upazila: '',
        union: '',
        village: '',
        range: '',
        station: '',
        bloodGroup: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-1433" data-mp="2id7q8vx5hgjm">
          {currentStep === 0 && <div className="space-y-4" data-id="element-1434" data-mp="1jarqzpepoext">
              <div className="grid grid-cols-2 gap-4" data-id="element-1435" data-mp="3p4st1ow165b0">
                <div data-id="element-1436" data-mp="3p7dx8kjswxbx">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1437" data-mp="3l48wamfdd3pe">
                    Photo Upload
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1438" data-mp="1o4mq8ote4opx" />
                </div>
                <div data-id="element-1439" data-mp="230vq9sl3v63e">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1440" data-mp="231dhgaswuu4g">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1441" data-mp="270cukiospx6z" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1442" data-mp="j4ok3gaskdyc">
                <div data-id="element-1443" data-mp="j2bvwlefx7cu">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1444" data-mp="f330lc3r51f6">
                    Father's Name
                  </label>
                  <input type="text" value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1445" data-mp="a4jdv9hc3llr" />
                </div>
                <div data-id="element-1446" data-mp="o2hmrzcvyptv">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1447" data-mp="o39a6mwbxh92">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1448" data-mp="1gsghobdrhh6g" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1449" data-mp="17ulixv9ihmay">
                <div data-id="element-1450" data-mp="17t0l9wrwhn8v">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1451" data-mp="1cu7r3qahgccw">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1452" data-mp="ytna8zo4oqm1" />
                </div>
                <div data-id="element-1453" data-mp="3c0d6385a8mvw">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1454" data-mp="3c37qizoaq7pb">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1455" data-mp="3l1jojmrhs7rs" />
                </div>
              </div>
              <div className="grid grid-cols-3 gap-4" data-id="element-1456" data-mp="2ekpl5zk151c5">
                <div data-id="element-1457" data-mp="29mo1pdioz005">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1458" data-mp="29n66wznc0ok7">
                    Profession
                  </label>
                  <input type="text" value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1459" data-mp="32pioatd1ubrv" />
                </div>
                <div data-id="element-1460" data-mp="2eyvbbtoa0vyg">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1461" data-mp="2eyd7obzabfgi">
                    Age
                  </label>
                  <input type="number" value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1462" data-mp="252ig2rd32a1l" />
                </div>
                <div data-id="element-1463" data-mp="fmzdkuupe9x2">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1464" data-mp="kjpwdpxw7jm6">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1465" data-mp="pisqifcc45fd" />
                </div>
              </div>
            </div>}

          {currentStep === 1 && <div className="space-y-4" data-id="element-1466" data-mp="3a8ru6cmcjsc6">
              <div className="grid grid-cols-2 gap-4" data-id="element-1467" data-mp="3a7p241dafjuo">
                <div data-id="element-1468" data-mp="3282b66drl6hv">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1469" data-mp="327j2zhdx1wh1">
                    Division
                  </label>
                  <select value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1470" data-mp="2y5fp6m3ryfsl">
                    <option value="" data-id="element-1471" data-mp="2t8fkofmkpl3l">Select Division</option>
                    <option value="Khulna" data-id="element-1472" data-mp="2t5t5bttfy1at">Khulna</option>
                    <option value="Barisal" data-id="element-1473" data-mp="2o8b5qu1bcyfh">Barisal</option>
                    <option value="Dhaka" data-id="element-1474" data-mp="8hol16f1xyfz">Dhaka</option>
                    <option value="Chattogram" data-id="element-1475" data-mp="8g3qhgsqmfi4">Chattogram</option>
                    <option value="Rajshahi" data-id="element-1476" data-mp="3hsfh2qphyyb">Rajshahi</option>
                    <option value="Rangpur" data-id="element-1477" data-mp="1lggp1rh0m1ma">Rangpur</option>
                    <option value="Sylhet" data-id="element-1478" data-mp="1lex8dzrg5ojz">Sylhet</option>
                    <option value="Mymensingh" data-id="element-1479" data-mp="1qg32a0wufhv3">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-1480" data-mp="1cgk2bve6rctv">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1481" data-mp="1chd2uemjx63k">
                    District
                  </label>
                  <select value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1482" data-mp="254fzt2bkx8rp">
                    <option value="" data-id="element-1483" data-mp="2o324er6b1i0d">Select District</option>
                    <option value="Satkhira" data-id="element-1484" data-mp="2su1xflcazfxl">Satkhira</option>
                    <option value="Khulna" data-id="element-1485" data-mp="2svlevf9p3x0y">Khulna</option>
                    <option value="Bagerhat" data-id="element-1486" data-mp="148qu8r9c8pxl">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1487" data-mp="z8cvjztmmsc8">
                <div data-id="element-1488" data-mp="v7j4wyosuzfn">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1489" data-mp="v6rc1vml7ft2">
                    Upazila
                  </label>
                  <select value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1490" data-mp="qaanx1fe11fz">
                    <option value="" data-id="element-1491" data-mp="26mprch8cyy2q">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-1492" data-mp="26o96g4ia332x">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1493" data-mp="21vpsv7jlc7y4">Koyra</option>
                    <option value="Dacope" data-id="element-1494" data-mp="21u4z3k53ot1b">Dacope</option>
                    <option value="Mongla" data-id="element-1495" data-mp="2985slbw03sov">Mongla</option>
                    <option value="Sarankhola" data-id="element-1496" data-mp="2e67ahthoxlyr">Sarankhola</option>
                  </select>
                </div>
                <div data-id="element-1497" data-mp="2j4sfs7bsuvu2">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1498" data-mp="2j48tkef49la8">
                    Union
                  </label>
                  <select value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1499" data-mp="2n4srhk7iksxf">
                    <option value="" data-id="element-1500" data-mp="3awrgt83ssotk">Select Union</option>
                    <option value="Burigoalini" data-id="element-1501" data-mp="3ayazt6gu9dz1">Burigoalini</option>
                    <option value="Gabura" data-id="element-1502" data-mp="3fwm8hdvedifo">Gabura</option>
                    <option value="Munshiganj" data-id="element-1503" data-mp="1ftb9siyiwuwj">Munshiganj</option>
                    <option value="Koyra" data-id="element-1504" data-mp="1ftuq5v8izb8g">Koyra</option>
                    <option value="Dacope" data-id="element-1505" data-mp="1bs9j4qio9r66">Dacope</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1506" data-mp="1pk65sf1kn8v6">
                <div data-id="element-1507" data-mp="1kseh6a1z7d7o">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1508" data-mp="1ks62qdq7fzud">
                    Village
                  </label>
                  <select value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1509" data-mp="1zfr7sd6n494x">
                    <option value="" data-id="element-1510" data-mp="94wbaov30t61">Select Village</option>
                    <option value="Munshiganj" data-id="element-1511" data-mp="96fsqish5a9e">Munshiganj</option>
                    <option value="Gabura" data-id="element-1512" data-mp="2kryehyb5ga06">Gabura</option>
                    <option value="Shyamnagar" data-id="element-1513" data-mp="2kuklnwu4onhv">Shyamnagar</option>
                    <option value="Koyra" data-id="element-1514" data-mp="2ppzzwpw1slet">Koyra</option>
                    <option value="Dacope" data-id="element-1515" data-mp="2c0675whf9gzt">Dacope</option>
                  </select>
                </div>
                <div data-id="element-1516" data-mp="2g0zwmuaij3ut">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1517" data-mp="2g0gf3eoryhhb">
                    Range
                  </label>
                  <select value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1518" data-mp="223tgl7h6bj9a">
                    <option value="" data-id="element-1519" data-mp="3rfn5177jky95">Select Range</option>
                    <option value="Satkhira" data-id="element-1520" data-mp="2f7bj8smgzgoo">Satkhira</option>
                    <option value="Khulna" data-id="element-1521" data-mp="2f6jp7m8itr0i">Khulna</option>
                    <option value="Chandpai" data-id="element-1522" data-mp="2a7ozs1g1t47f">Chandpai</option>
                    <option value="Sarankhola" data-id="element-1523" data-mp="2aakvdj4fbgsp">Sarankhola</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-1524" data-mp="20iyp816y07wt">
                <div data-id="element-1525" data-mp="20gcha0g53qe2">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1526" data-mp="1wgtwr5s8dhbr">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-1527" data-mp="1rgpbz3kai0fq">
                    <option value="" data-id="element-1528" data-mp="3keci0tnslcar">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-1529" data-mp="20v6dnry0rb0">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-1530" data-mp="35gk76et6xc2w">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1531" data-mp="35hu59401mk9j">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1532" data-mp="3ffi342sy47vx">
                    <option value="" data-id="element-1533" data-mp="2bi5iny88trcc">Select Blood Group</option>
                    <option value="A+" data-id="element-1534" data-mp="2ga5o26731cgb">A+</option>
                    <option value="A-" data-id="element-1535" data-mp="2gaffzzbotton">A-</option>
                    <option value="B+" data-id="element-1536" data-mp="2l8qq8b5wa67e">B+</option>
                    <option value="B-" data-id="element-1537" data-mp="2l8gyai1ahoz2">B-</option>
                    <option value="AB+" data-id="element-1538" data-mp="1nlhyvzj7q2xh">AB+</option>
                    <option value="AB-" data-id="element-1539" data-mp="1nmt1vx4u36nj">AB-</option>
                    <option value="O+" data-id="element-1540" data-mp="1sjt765tv05dl">O+</option>
                    <option value="O-" data-id="element-1541" data-mp="1skl4bl33ub5z">O-</option>
                  </select>
                </div>
              </div>
            </div>}

          {currentStep === 2 && <div className="space-y-4" data-id="element-1542" data-mp="21lsqj4scjljp">
              <div data-id="element-1543" data-mp="21iofbnggrpjj">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1544" data-mp="38yupy7fyplt4">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1545" data-mp="3cyv55uavy118" />
              </div>
              <div data-id="element-1546" data-mp="sjzk8v3jz3fx">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1547" data-mp="sj7wu7k40c0q">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1548" data-mp="njlgvqcwcho8" />
              </div>
              <div data-id="element-1549" data-mp="9lwzisi1fsnx">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-1550" data-mp="9nhs4cksl1j5">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-1551" data-mp="23yms96wo6vtq" />
              </div>
            </div>}

          {currentStep === 3 && <div className="space-y-6" data-id="element-1552" data-mp="2my12lbsy3xqz">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1553" data-mp="2951nhax2s5jy">
                <div className="flex items-center justify-between mb-3" data-id="element-1554" data-mp="292f7cmw4chq4">
                  <h4 className="font-semibold text-gray-900" data-id="element-1555" data-mp="2e4e7zp0h50jd">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1556" data-mp="31r2uko0fhh6b">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1557" data-mp="2wtb6k52wmf7e">
                  <div data-id="element-1558" data-mp="2wvx9tsiri8jt">
                    <span className="text-gray-600" data-id="element-1559" data-mp="1gfb7ewbvutl7">Name:</span>{' '}
                    <span className="font-medium" data-id="element-1560" data-mp="1gi74yjjtjg94">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1561" data-mp="1du3f5ih8sk4z">
                    <span className="text-gray-600" data-id="element-1562" data-mp="1dxiywylv2hcq">NID:</span>{' '}
                    <span className="font-medium" data-id="element-1563" data-mp="18vjstgyql6c3">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1564" data-mp="1hx02fmhq94f9">
                    <span className="text-gray-600" data-id="element-1565" data-mp="1hwrso3gwif8a">Profession:</span>{' '}
                    <span className="font-medium" data-id="element-1566" data-mp="u75tvh4fy20t">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-4" data-id="element-1567" data-mp="13wyujn31owqa">
                <div className="flex items-center justify-between mb-3" data-id="element-1568" data-mp="13yjnx9dmi9mk">
                  <h4 className="font-semibold text-gray-900" data-id="element-1569" data-mp="z5qi0i6f4v8w">
                    Address Details
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-1570" data-mp="bf4nzut91bhw">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-1571" data-mp="p3eoovvc0i11">
                  <div data-id="element-1572" data-mp="p1k79rj9r81p">
                    <span className="text-gray-600" data-id="element-1573" data-mp="u315ffadcgel">Division:</span>{' '}
                    <span className="font-medium" data-id="element-1574" data-mp="u0odqaet6roc">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1575" data-mp="12u1h66ai1boo">
                    <span className="text-gray-600" data-id="element-1576" data-mp="12utcdg06p7ef">District:</span>{' '}
                    <span className="font-medium" data-id="element-1577" data-mp="17t4hjdfjatqb">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1578" data-mp="1hs25of91sl8s">
                    <span className="text-gray-600" data-id="element-1579" data-mp="1hslpk1i9djpg">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-1580" data-mp="3eklxhczn5457">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1581" data-mp="3jjys4jwr7fic">
                    <span className="text-gray-600" data-id="element-1582" data-mp="3jljkq3zicodk">Union:</span>{' '}
                    <span className="font-medium" data-id="element-1583" data-mp="20q5buj7yudee">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1584" data-mp="1rvr0usugxp13">
                    <span className="text-gray-600" data-id="element-1585" data-mp="1rx22on4csmpk">Village:</span>{' '}
                    <span className="font-medium" data-id="element-1586" data-mp="1mxpgm4lb3jo1">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1587" data-mp="2jlc7lmzm29u3">
                    <span className="text-gray-600" data-id="element-1588" data-mp="2fm4j5rn949ih">Range:</span>{' '}
                    <span className="font-medium" data-id="element-1589" data-mp="2fjqovl0eb1bz">
                      {formData.range || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-1590" data-mp="25mm15gqwixt2">
                    <span className="text-gray-600" data-id="element-1591" data-mp="25n5ml7frg4bu">Station:</span>{' '}
                    <span className="font-medium" data-id="element-1592" data-mp="z8mq078p2ghe">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}
    </div>;
}